<template>
  <div><img src="@/assets/loading.gif" width="100%" /></div>
</template>
<script>
import { userLogin } from '../api/forms'
export default {
  data () {
    return {
      openId: this.$route.query.openId || '',
      avatar: this.$route.query.avatar || '',
      nickName: this.$route.query.nickname || ''
    }
  },
  created () {
    this.getOpenId()
  },
  methods: {
    getOpenId () {
      if (this.openId) {
        this.$cookies.set('openId', this.openId)
        this.$cookies.set('avatar', this.avatar)
        this.$cookies.set('nickName', this.nickName)
        this.getAuthorize()
      } else {
        // let url = 'http://192.168.1.4:8080/';
        // let url = 'http://thermofisher.cad.from.al-ecs.synconize.cn/';
        let url = 'http://thermofisher-cad-from-three.ms-vm.synconize.com/'
        window.location.href = `http://wx.oauth.synconize.com/wechat/oauth/?appId=wxfb99f0fc1ca20ac0&mode=hash&redirectUrl=${url}`
      }
    },
    // 微信授权登录
    getAuthorize () {
      let data = {
        openId: this.openId,
        wxHead: this.avatar,
        wxName: this.nickName
      }
      userLogin(data)
        .then((result) => {
          if (result.code === 200) {
            this.$router.push('/State')
          }
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }
}
</script>
